// components/GoogleAnalytics.tsx
'use client';

import Script from 'next/script';
import getConfig from 'next/config';

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID || 'G-0P7N8T44VK';
const { publicRuntimeConfig } = getConfig();
const enableGtm = publicRuntimeConfig.enableGtm;

export default function GoogleAnalytics() {
  if (!enableGtm) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="lazyOnload"
      />
      <Script
        id="gtag-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_MEASUREMENT_ID}', {
                page_path: window.location.pathname,
              });
          `,
        }}
      />
    </>
  );
}
